"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.setDialogSize = void 0;
const DesignSystem_1 = require("./..");
const setDialogSize = (tokens) => {
    tokens.designTokens.set(DesignSystem_1.designTokens.dialogSizeXXSWidth, '288px');
    tokens.designTokens.set(DesignSystem_1.designTokens.dialogSizeXSWidth, '480px');
    tokens.designTokens.set(DesignSystem_1.designTokens.dialogSizeSWidth, '600px');
    tokens.designTokens.set(DesignSystem_1.designTokens.dialogSizeMWidth, '720px');
    tokens.designTokens.set(DesignSystem_1.designTokens.dialogSizeLWidth, '800px');
    tokens.designTokens.set(DesignSystem_1.designTokens.dialogSizeXLWidth, '880px');
    tokens.designTokens.set(DesignSystem_1.designTokens.dialogSizeXXLWidth, '960px');
    tokens.designTokens.set(DesignSystem_1.designTokens.dialogSizeXXSHeight, '160px');
    tokens.designTokens.set(DesignSystem_1.designTokens.dialogSizeXSHeight, '260px');
    tokens.designTokens.set(DesignSystem_1.designTokens.dialogSizeSHeight, '320px');
    tokens.designTokens.set(DesignSystem_1.designTokens.dialogSizeMHeight, '400px');
    tokens.designTokens.set(DesignSystem_1.designTokens.dialogSizeLHeight, '432px');
    tokens.designTokens.set(DesignSystem_1.designTokens.dialogSizeXLHeight, '560px');
    tokens.designTokens.set(DesignSystem_1.designTokens.dialogSizeXXLHeight, '700px');
};
exports.setDialogSize = setDialogSize;
//# sourceMappingURL=setDialogSizes.js.map